exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.concept-title {\r\n  color: #31b34a;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-top: 10px;\n}\n.chapter-title {\r\n  color: #000000;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  margin-top: 10px;\n}\n.t-row {\r\n  font-size: 14px;\r\n  color:#31b34a;\n}\n.paragraph {\r\n  margin-top: 20px;\n}\n.table8 {\r\n  max-height: 250px;\r\n  overflow-x: none;\r\n  overflow-y: auto;\r\n  margin-top: 10px;\r\n  padding-left:25px;\n}\n.table10 {\r\n  max-height: 250px;\r\n  overflow-x: none;\r\n  overflow-y: auto;\r\n  margin-top: 10px;\n}\n#link:hover{\r\n  color:#007bff;\r\n  text-decoration: underline;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27a8a3f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConceptPane.vue
// module id = Hm1V
// module chunks = 1